import { render, staticRenderFns } from "./CertificatesDataTable.vue?vue&type=template&id=294a4f39"
import script from "./CertificatesDataTable.vue?vue&type=script&lang=js"
export * from "./CertificatesDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports